"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceModule = void 0;
const graph_1 = require("@derivation-tech/context/dist/utils/graph");
const dataSource_1 = require("./dataSource");
const inverse_1 = require("./inverse");
class DataSourceModule extends graph_1.Graph {
    constructor(ctx, options) {
        super(options.endpoint, options.retryOption);
        this.ctx = ctx;
        this.depth = options.inverse ? new inverse_1.InverseDepth(this) : new dataSource_1.Depth(this);
        this.funding = new dataSource_1.Funding(this);
        this.history = options.inverse ? new inverse_1.InverseHistory(this) : new dataSource_1.History(this);
        this.kline = options.inverse ? new inverse_1.InverseKline(this) : new dataSource_1.Kline(this);
        this.liquidity = options.inverse ? new inverse_1.InverseLiquidity(this) : new dataSource_1.Liquidity(this);
        this.volume = new dataSource_1.Volume(this);
        this.statistics = new dataSource_1.Statistics(this);
        this.user = new dataSource_1.User(this);
    }
}
exports.DataSourceModule = DataSourceModule;
